import { unitMapping, type Unit } from '@sorare/core/src/lib/style';
import type { HexColor } from '@sorare/core/src/style/types';

export const TargetIcon = ({
  color,
  size = 2,
}: {
  color: HexColor;
  size?: Unit;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 11 10"
      fill="none"
      style={{ height: unitMapping[size] }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.49999 8.5998C7.48822 8.5998 9.09999 6.98803 9.09999 4.9998C9.09999 3.01158 7.48822 1.3998 5.49999 1.3998C3.51177 1.3998 1.89999 3.01158 1.89999 4.9998C1.89999 6.98803 3.51177 8.5998 5.49999 8.5998ZM5.49955 7.17436C6.70077 7.17436 7.67455 6.20058 7.67455 4.99936C7.67455 3.79815 6.70077 2.82436 5.49955 2.82436C4.29834 2.82436 3.32455 3.79815 3.32455 4.99936C3.32455 6.20058 4.29834 7.17436 5.49955 7.17436Z"
        fill={color}
      />
      <path
        d="M6.10058 2.6001L6.10058 0.200097H4.90058L4.90058 2.6001H6.10058Z"
        fill={color}
      />
      <path
        d="M0.700287 4.40039L3.10029 4.40039V5.60039H0.700287V4.40039Z"
        fill={color}
      />
      <path
        d="M10.3 4.40039L7.89999 4.40039V5.60039H10.3L10.3 4.40039Z"
        fill={color}
      />
      <path
        d="M6.10058 9.7998L6.10058 7.3998H4.90058L4.90058 9.7998L6.10058 9.7998Z"
        fill={color}
      />
    </svg>
  );
};
